import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// components
import Button3d from '../../../../components/ButtonWrapper/components/Button3d';
import Chat from '../../../../components/Chat';
import Brief from '../../../../components/Brief';

const CommCenterProject = () => {
    const [tabState, setTabState] = useState('brief')

    return (
        <div className="appCommCenter">
            <div className="appWorkbenchPanel commCenterPanel">
                <Button3d
                    changeFn={() => setTabState('brief')}
                    name="brief"
                    checked={tabState === 'brief'}>
                    {__('Brief', 'soundbetween')}
                </Button3d>
                <Button3d
                    changeFn={() => setTabState('chatClient')}
                    name="chatClient"
                    checked={tabState === 'chatClient'}>
                    {__('Client', 'soundbetween')}
                </Button3d>
                <Button3d
                    changeFn={() => setTabState('chat')}
                    name="chat"
                    checked={tabState === 'chat'}>
                    {__('Team', 'soundbetween')}
                </Button3d>
            </div>
            <div className="appDashboard__workbench">
                {tabState === 'brief' && <Brief/>}
                {tabState === 'chatClient' && <Chat type="CUSTOMER"/>}
                {tabState === 'chat' && <Chat type="TEAM"/>}
            </div>
        </div>
    )
}

export default CommCenterProject;
